module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon29.b35455cf.png";